import httpClient from "@/store/httpClient";

export default {
  namespaced: true,
  state: { bahn1Data: null },
  mutations: {
    SET_BAHN1(state, data) {
      state.bahn1Data = data;
    }
  },
  actions: {
    async loadBahn1({ commit }) {
      const response = await httpClient.get("/bahn-1/for-user");
      if (response.status === 200) commit("SET_BAHN1", response.data);
    }
  },
  getters: {
    dataLoaded(state) {
      return state.bahn1Data !== null;
    },
    termin: state => state.bahn1Data?.Termin ?? null,
    ort: state => state.bahn1Data?.Ort ?? null,
    eventProgramm: state => state.bahn1Data?.EventProgramm ?? null,
    mitwirkende: state => state.bahn1Data?.Mitwirkende ?? null,
    teaserVid: state => state.bahn1Data?.TeaserVid ?? null,
    ansprechsperson: state => state.bahn1Data?.Ansprechsperson ?? null,
    bahn1Updates: state => state.bahn1Data?.Bahn1Updates ?? null,
    lastUpdated: state => state.bahn1Data?.updated_at ?? null,
    recap: state => state.bahn1Data?.Recap ?? null,
    bildergallerie: state => state.bahn1Data?.Bildergallerie ?? null,
    wichtigstenImpulse: state => state.bahn1Data?.WichtigstenImpulse ?? [],
    statements: state => state.bahn1Data?.Statements ?? null,
    impulseNew: state => state.bahn1Data?.ImpulseNEW ?? null,
    postEvent: state => !!state.bahn1Data?.PostEventSwitch,
    anmeldungEventId: state => state.bahn1Data?.AnmeldungEventId ?? null,
    angemeldet: state => !!state.bahn1Data?.Angemeldet
  }
};
